import { MyTableComponent } from "components"
import { useEffect, useState, useRef } from "react"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
import openIcon from "./selecticon.png"

export const Streets = () => {
 // language translator
 const { t } = useTranslation("translation")
 const containerRef = useRef<HTMLDivElement>(null)
 const [isAtStart, setIsAtStart] = useState(true)
 const [isAtEnd, setIsAtEnd] = useState(false)

 const data = [
  {
   info1: "",
   info2: "",
   info3: "Hinzufugen",
  },
  {
   info1: "",
   info2: "",
   info3: "Hinzufugen",
  },
  {
   info1: "",
   info2: "",
   info3: "Hinzufugen",
  },

  {
   info1: "",
   info2: "",
   info3: "Hinzufugen",
  },
  {
   info1: "",
   info2: "",
   info3: "Hinzufugen",
  },
  {
   info1: "",
   info2: "",
   info3: "Hinzufugen",
  },
 ]

 const columns = [
  {
   Header: t("art"),
   Cell: () => (
    <div className="bg-gray py-2 flex justify-between items-center rounded px-2">
     <input
      className="w-full  outline-none bg-transparent"
      min="0"
      max="999"
      type="number"
      placeholder="0"
     />
    </div>
   ),
  },
  {
   Header: t("number"),
   Cell: ({ row }: any) => <div className="bg-gray py-5 rounded">{row.original.info1}</div>,
  },
  {
   Header: "Name",
   Cell: ({ row }: any) => <div className="bg-gray py-5 rounded">{row.original.info2}</div>,
  },

  {
   Header: t("action"),
   Cell: ({ row }: any) => (
    <div className=" text-light-blue bg-[#bac9ff] border border-[#bac9ff] rounded py-2">
     {row.original.info3}
    </div>
   ),
  },
 ]

 useEffect(() => {
  if (containerRef.current) {
   containerRef.current.addEventListener("scroll", handleScroll)
   return () => {
    // eslint-disable-next-line
    containerRef.current?.removeEventListener("scroll", handleScroll)
   }
  }
  // eslint-disable-next-line
 }, [])
 //   horizontal scroll method for changing the color of active button
 const handleScroll = () => {
  if (containerRef.current) {
   setIsAtStart(containerRef.current.scrollLeft === 0)
   setIsAtEnd(
    containerRef.current.scrollLeft + containerRef.current.clientWidth ===
     containerRef.current.scrollWidth,
   )
  }
 }
 //   scrollLeft method
 const scrollLeft = () => {
  if (containerRef.current) {
   containerRef.current.scrollLeft -= 100
  }
 }
 //   scrollRight method
 const scrollRight = () => {
  if (containerRef.current) {
   containerRef.current.scrollLeft += 100
  }
 }

 return (
  <div className="w-full lg:w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full pt-5">
   <div className="flex justify-between items-center w-[98%] mx-auto pb-4">
    <h1 className="font-semibold text-2xl">{t("partNode")}</h1>

    <div className="flex w-[6%]  justify-between">
     <button
      onClick={scrollLeft}
      className={`h-6 w-6 rounded-lg flex items-center justify-center ${
       isAtStart ? "opacity-40 bg-white" : "bg-white"
      } `}
     >
      <img className="rotate-[-90deg]" src={openIcon} alt="prev" />
     </button>
     <button
      onClick={scrollRight}
      className={`h-6 w-6 rounded-lg flex items-center justify-center ${
       isAtEnd ? "opacity-40 bg-white" : "bg-white"
      }`}
     >
      <img className="rotate-90" src={openIcon} alt="next" />
     </button>
    </div>
   </div>
   <div className="flex w-full overflow-x-auto hide-scroll-icon" ref={containerRef}>
    <div className="min-w-[70%] py-5">
     <Box bg="highlight" color="text-black">
      <div className="py-3 px-3">
       <h1 className="Jakarta-font font-semibold text-lg">Testserver: testanlage 01 Gera</h1>
      </div>
     </Box>

     {/* ====== TableComponent ====== */}
     <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
    </div>
    <div className="min-w-[70%] py-5 ml-3">
     <Box bg="highlight" color="text-black">
      <div className="py-3 px-3">
       <h1 className="Jakarta-font font-semibold text-lg">Testserver: testanlage 01 Gera</h1>
      </div>
     </Box>

     {/* ====== TableComponent ====== */}
     <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
    </div>
   </div>
  </div>
 )
}
